<template>
  <!-- 初审详情页面 -->
  <div class="initialReviewDetail">
    <div v-if="!readonly" class="searchBox">
      <div>【{{ $t('admin-judge/hasAmount') }} {{ product.review_num }}{{ product.review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }} / {{ $t('admin-judge/productAmount') }} {{ product.total }}{{ product.review_num > 1 ? $t('admin-judge/pieces') : $t('admin-judge/piece') }}】</div>
    </div>
    <div style="margin: 8px 0;">{{ product.pi_code || '' }}</div>
    <div class="image-container">
      <img v-for="(item, index) in product.image" :key="index" :src="item.thumb_image_url" class="img" style="cursor:pointer;" @click="preview(index)">
    </div>
    <!-- 视频展示区域 -->
    <div v-if="product.video && product.video.length > 0" style="margin: 10px 0;">
      <div style="margin-bottom: 8px; font-weight: bold;">视频：</div>
      <div class="video-list">
        <div
          v-for="(item, index) in product.video"
          :key="`video-${index}`"
          class="video-list-item"
          @click="playVideo(item.whole_image_url)"
        >
          <div class="video-item-content">
            <div class="video-icon">
              <a-icon type="video-camera" />
            </div>
            <div class="video-details">
              <div class="video-name">视频 {{ index + 1 }}</div>
              <div class="video-status">点击播放视频</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" label-align="left">
      <a-form-item
        :label="$t('user-productInfo-product/productName')"
        style="margin: 0;"
      >
        <span>{{ product.name_cn || '' }}</span>
      </a-form-item>
      <a-form-item
        :label="$t('user-productInfo-product/type')"
        style="margin-bottom: 20px;"
      >
        <span>{{ product.category_cn || '' }}</span>
      </a-form-item>
    </a-form>
    <a-form layout="vertical">
      <a-form-item
        :label="$t('admin-judge/zdescription')"
        style="margin-bottom: 12px;height: auto;"
      >
        <div>{{ product.description_cn || '' }}</div>
      </a-form-item>
    </a-form>
    <div><font color="#ff6400">{{ $t('admin-judge/tip3') }}</font></div>
    <div><font color="#ff6400">{{ $t('admin-judge/tip4') }}</font></div>
    <footer>
      <a-button @click="goback">
        {{ $t('view-components-components/return') }}
      </a-button>
      <a-button v-if="!readonly" :class="{ disabled: !product.prev_id}" @click="go(-1)">
        {{ $t('admin-judge/pre') }}
      </a-button>
      <a-button
        v-if="!readonly"
        type="primary"
        @click="go(0)"
      >
        初审
      </a-button>
      <a-button v-if="!readonly" :class="{ disabled: !product.next_id}" @click="go(1)">
        {{ $t('admin-judge/next') }}
      </a-button>
    </footer>
    <Modal
      :show-modal="showModal"
      :cancel-text="$t('register-verify/close')"
      :confirm-text="$t('user-tools/save')"
      @cancel="showModal = false"
      @confirm="submit"
    >
      <div>
        <div>初审规则</div>
        <div style="font-size: 16px;">每组有5个专家，点击"推荐"即可对该作品进行初评，点击推荐计1分，反之不推荐计0分，最高累计五分，系统将保存您的评分结果并为您跳转至下一件参赛作品。</div>
        <div style="margin-top: 10px; color: #ff4d4f; font-weight: bold;">重要提示：您也可以回到上一件作品，并修改作品的推荐。</div>
        <div style="margin-top: 10px;">初审结果</div>
        <div>
          <a-form-item>
            <!-- 评分输入框 -->
            <div style="margin-bottom: 20px;">
              <div style="margin-bottom: 10px; font-weight: bold;">评分 (0-10分，保留一位小数)：</div>
              <a-input-number
                v-model="score"
                :min="0"
                :max="10"
                :step="0.1"
                :precision="1"
                style="width: 200px;"
                placeholder="请输入评分"
              />
              <div style="margin-top: 8px; color: #666; font-size: 12px;">
                <div>评分标准：</div>
                <div>1-3分：差 | 4-5分：及格 | 6-7分：中等 | 8-10分：优秀</div>
              </div>
            </div>
          </a-form-item>
          <div style="margin-top: 50px;display: flex;">
            <span style="width: 8em;">初审意见：</span>
            <a-input v-model="review_opinion" placeholder="请输入初审意见" />
          </div>
        </div>
      </div>
    </Modal>
    <Modal
      :show-modal="showModal2"
      @cancel="showModal2 = false"
      @confirm="go(tag, true);showModal2 = false"
    >
      <div>
        <span v-if="!score && score !== 0 && (tag === -1 && !product.prev_status)">当前作品还未初审，是否进入上一件作品？</span>
        <span v-if="!score && score !== 0 && (tag === 1 && !product.next_status)">当前作品还未初审，是否进入下一件作品？</span>
        <span v-if="!score && score !== 0 && (tag === -1 && product.prev_status)">当前作品还未初审，是否进入上一个类别？</span>
        <span v-if="!score && score !== 0 && (tag === 1 && product.next_status)">当前作品还未初审，是否进入下一个类别？</span>
        <span v-if="score !== null">{{ $t('admin-judge/whetherNext') }}</span>
      </div>
    </Modal>
    <PreviewImage v-if="previewVisible" :images="images" :index="imagesIndex" @closePreview="closePreview" />
    <!-- 视频播放模态框 -->
    <a-modal
      v-model="videoModalVisible"
      :footer="null"
      :closable="true"
      :mask-closable="true"
      :keyboard="true"
      :wrap-class-name="'video-modal'"
      width="80%"
      @cancel="closeVideoModal"
    >
      <div class="video-container">
        <video
          v-if="currentVideoUrl"
          :src="currentVideoUrl"
          controls
          autoplay
          class="video-player"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </a-modal>
  </div>
</template>

<script>
// 统一使用 /reviews/product 接口
import { getProductReviewDetail } from '@/api/product'
import Modal from '@/views/components/Modal.vue'
import PreviewImage from '@/views/components/PreviewImage'

export default {
  components: {
    Modal,
    PreviewImage
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      product: {},
      showModal: false,
      showModal2: false,
      score: null,
      tag: 0,
      images: [],
      imagesIndex: 0,
      previewVisible: false,
      timer: -1,
      review_opinion: '',
      videoModalVisible: false,
      currentVideoUrl: ''
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      // 使用 /reviews/product 接口获取初审作品详情
      const productId = this.$route.query.id || this.id
      const userId = this.$route.query.user_id || this.user.id
      const type = 1 // 初审类型为1

      getProductReviewDetail(productId, userId, type).then(res => {
        this.product = res.product || res
        this.score = this.product.score
        this.review_opinion = this.product.review_opinion
        document.getElementsByClassName('ant-layout')[1].scrollTop = 0
      }).catch(error => {
        console.error('获取初审作品详情失败:', error)
        this.$message.error('获取初审作品详情失败，请重试')
      })
    },
    go(tag, bool) {
      if (this.timer !== -1) {
        clearTimeout(this.timer)
        this.timer = -1
      }
      switch (tag) {
        case -1: {
          if ((this.score === null || this.product.prev_status) && !bool) {
            this.tag = -1
            this.showModal2 = true
          } else if (this.product.prev_id) {
            this.$router.replace({ query: { id: this.product.prev_id, user_id: this.$route.query.user_id }})
            this.getDetail()
          }
          break
        }
        case 0: {
          this.showModal = true
          break
        }
        case 1: {
          if ((this.score === null || this.product.next_status) && !bool) {
            this.tag = 1
            this.showModal2 = true
          } else if (this.product.next_id) {
            this.$router.replace({ query: { id: this.product.next_id, user_id: this.$route.query.user_id }})
            this.getDetail()
          }
          break
        }
        default: break
      }
    },
    submit() {
      if (this.score === null) {
        return this.$message.warning({ content: '请输入评分', key: 'message', duration: 4 })
      }
      if (!this.review_opinion.trim()) {
        return this.$message.warning({ content: '请输入初审意见', key: 'message', duration: 4 })
      }
      this.showModal = false
      // TODO: 调用初审相关的API接口
      // const data = {
      //   score: this.score,
      //   review_opinion: this.review_opinion
      // }
      // updateReviewsProduct(this.$route.query.id || this.id, 1, data).then(res => {
      //   if (this.id) {
      //     this.$message.success({ content: '初审成功', key: 'message', duration: 4 })
      //     this.showModal = false
      //   } else {
      //     this.$message.success({ content: '初审成功', key: 'message', duration: 4 })
      //     if (res.status === 1) {
      //       this.$router.push({ path: '/admin/initialReview', query: { initialReviewConfirmTip: true }})
      //     } else {
      //       clearTimeout(this.timer)
      //       this.timer = setTimeout(() => {
      //         this.go(1)
      //       }, 1000)
      //     }
      //   }
      // })

      // 临时模拟成功
      this.$message.success({ content: '初审成功', key: 'message', duration: 4 })
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.go(1)
      }, 1000)
    },
    preview(index) {
      // 使用 whole_image_url 字段显示大图
      this.images = this.product.image.map(item => item.whole_image_url)
      this.imagesIndex = index
      this.previewVisible = true
    },
    closePreview() {
      this.previewVisible = false
    },
    goback() {
      if (this.id) {
        this.$emit('hideDetail')
      } else {
        this.$router.back()
      }
    },
    playVideo(src) {
      this.currentVideoUrl = src
      this.videoModalVisible = true
    },
    closeVideoModal() {
      this.videoModalVisible = false
      this.currentVideoUrl = ''
    }
  }
}
</script>
<style scoped>
  .initialReviewDetail {
    font-size: 14px;
  }

  .searchBox {
    padding: 17px 20px;
    background: #ffffff;
  }

  .image-container {
    overflow-x: auto;
    white-space: nowrap;
    margin-bottom: 10px;
  }

  .img {
    width: 350px;
    height: auto;
    margin-right: 10px;
    object-fit: cover;
    display: inline-block;
    vertical-align: top;
  }

  /* 视频列表样式 */
  .video-list {
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background: #fff;
    overflow: hidden;
  }

  .video-list-item {
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.3s;
  }

  .video-list-item:last-child {
    border-bottom: none;
  }

  .video-list-item {
    cursor: pointer;
  }

  .video-list-item:hover {
    background-color: #fafafa;
  }

  .video-item-content {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
  }

  .video-icon {
    font-size: 20px;
    color: #1890ff;
    flex-shrink: 0;
  }

  .video-details {
    flex: 1;
    min-width: 0;
  }

  .video-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .video-status {
    font-size: 12px;
    color: #666;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .video-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .video-player {
    max-width: 100%;
    max-height: 80vh;
  }

  .initialReviewDetail .ant-form .label {
    font-size: 14px;
  }

  footer{
    text-align: center;
    padding: 19px 0 39px;
  }

  footer button {
    margin-left: 16px;
  }
</style>
<style>
  .initialReviewDetail .radioBox {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    display: flex;
    text-align: center;
  }

  .initialReviewDetail .radio {
    margin: -15px 4px 0;
  }

  .initialReviewDetail .radioLabel {
    display: inline-block;
    width: 40px;
    margin-top: 15px;
  }

  .initialReviewDetail .radioBox .ant-radio {
    margin: 16px 8px 8px;
  }

  .initialReviewDetail .tagName {
    position: relative;
    top: 45px;
  }

  .initialReviewDetail .tagScore {
    margin-top: -25px;
    position: relative;
    top: 45px;
  }
</style>

<style>
  .video-modal .ant-modal-content {
    background: rgba(0, 0, 0, 0.9);
    border: none;
  }

  .video-modal .ant-modal-body {
    padding: 0;
    background: transparent;
  }

  .video-modal .ant-modal-close {
    color: #fff;
  }

  .video-modal .ant-modal-close:hover {
    color: #fff;
    background: rgba(255, 255, 255, 0.1);
  }
</style>
